import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  Action_GetDMGroupCategories,
  Action_DeleteDMGroupCategories,
  Action_SaveDMGroupCategories,
  Action_SaveThietLapGiaNhom
} from "actions/DanhMuc/DanhMucNhomSanPham/actionTypes";
import {
  Index_getDMGroupCategoriesSuccess,
  Index_DeleteDMGroupCategoriesSuccess,
  Index_DeleteDMGroupCategoriesFailed,
  Index_SaveDMGroupCategoriesSuccess,
  Index_SaveDMGroupCategoriesFailed,
  Index_SaveThietLapGiaNhomSuccess,
  Index_SaveThietLapGiaNhomFailed
} from "actions/DanhMuc/DanhMucNhomSanPham";
import danhMucNhomSanPhamApi from "service/DanhMucService/DanhMucNhomSanPhamApi";
import { pushNotification } from "utils/notifications";
import { CheckTokenReload } from 'utils/utils';

function* Saga_getDMGroupCategories(action) {
  try {
    const response = yield call(danhMucNhomSanPhamApi.getDanhMucGroupCategories, action.payload);
    CheckTokenReload(response);
    if (response.data) {
      yield put(Index_getDMGroupCategoriesSuccess(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}

function* Saga_saveNhomSanPham(action) {
  try {
    const response = yield call(danhMucNhomSanPhamApi.saveNhomSanPham, action.payload);
    CheckTokenReload(response);
    if (response.status == 200) {
      pushNotification("Lưu thông tin thành công", "success", "TOP_RIGHT", 2000);
      yield put(Index_SaveDMGroupCategoriesSuccess(response.data));
    } else {
      pushNotification(response.data, "error", "TOP_RIGHT", 2000);
      yield put(Index_SaveDMGroupCategoriesFailed(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}

function* Saga_saveThietLapGiaNhom(action) {
  try {
    const response = yield call(danhMucNhomSanPhamApi.saveThietLapGiaNhom, action.payload);
    CheckTokenReload(response);
    if (response.status == 200) {
      pushNotification("Lưu thông tin thành công", "success", "TOP_RIGHT", 2000);
      yield put(Index_SaveThietLapGiaNhomSuccess(response.data));
    } else {
      pushNotification(response.data, "error", "TOP_RIGHT", 2000);
      yield put(Index_SaveThietLapGiaNhomFailed(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}

function* Saga_deleteNhomSanPham(action) {
  try {
    const response = yield call(danhMucNhomSanPhamApi.deleteNhomSanPham, action.payload);
    CheckTokenReload(response);
    if (response.status === 200) {
      pushNotification("Xóa nhóm thành công", "success", "TOP_RIGHT", 2000);
      yield put(Index_DeleteDMGroupCategoriesSuccess(response.data));
    } else {
      pushNotification(response.data, "error", "TOP_RIGHT", 2000);
      yield put(Index_DeleteDMGroupCategoriesFailed(response.data));
    }
  } catch (error) {
    pushNotification("Get data failure", "error", "TOP_RIGHT", 1000);
  }
}

function* watch_GetDMGroupCategories() {
  yield takeLatest(Action_GetDMGroupCategories, Saga_getDMGroupCategories);
}
function* watch_SaveNhomSanPham() {
  yield takeLatest(Action_SaveDMGroupCategories, Saga_saveNhomSanPham);
}
function* watch_DeleteNhomSanPham() {
  yield takeLatest(Action_DeleteDMGroupCategories, Saga_deleteNhomSanPham);
}

function* watch_SaveThietLapGiaNhom() {
  yield takeLatest(Action_SaveThietLapGiaNhom, Saga_saveThietLapGiaNhom);
}
//endregion watchAPI

export default function* sagas() {
  yield all([watch_GetDMGroupCategories(), watch_SaveNhomSanPham(), watch_DeleteNhomSanPham(), watch_SaveThietLapGiaNhom()]);
}
